import { ShapeState } from "./types";
import { UmbrellaModel } from "@/models/products/umbrella";

export const getModel = (state: ShapeState): UmbrellaModel | null => {
  return state.model;
};
